import React, { useEffect } from 'react'
import { useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import Button from '../../../components/button'
import DataTable from '../../../components/datatable'
import DashboardLayout from '../../../components/layouts/dashboard'
import {
  useAccessPayslipById,
  useCheckTransactionStatus,
  useRefBasicPayrollView,
  useRevertPayroll,
  useSendSingleBasicPayslip,
} from '../../../redux/payroll/hook'
import { PAGINATION_DEFAULT } from '../../../utils/constants'
import BasicPayrollDetailedView from '../../../components/modal/payroll/basic-payroll-full-view'
import {
  isLoading,
  setIsLoading,
} from '../../../redux/components/components-slice'
import { useSelector } from 'react-redux'
import UnauthorizedPage from '../../errors/unauthorized'
import BasicPayslipPDFContent from '../../../utils/pdf-content/basic-payslip'
import html2pdf from 'html2pdf.js/dist/html2pdf.min'
import ReactDOMServer from 'react-dom/server'
import { store } from '../../../redux'
import WarningSVG from '../../../assets/svg/warning.svg'

const BasicPayrollViewPage = () => {
  const { user } = useSelector((state) => state.userSlice)
  const { company } = useSelector((state) => state.companySlice)
  const [unauthorized, setUnauthorized] = useState(false)

  useEffect(() => {
    if (user) {
      if (user.permissions.company_permission.role !== 'Owner') {
        if (
          user.permissions.company_permission.payroll_read !== 1 ||
          user.permissions.payroll_permission?.basic_payroll_write !== 1
        ) {
          setUnauthorized(true)
        }
      }
    }
  }, [user])

  const loading = useSelector(isLoading)

  const [pagination, setPagination] = useState({
    limit: PAGINATION_DEFAULT.limit,
    page: PAGINATION_DEFAULT.page,
    statusFilter: PAGINATION_DEFAULT.statusFilter,
    search: '',
  })

  const { refId } = useParams()
  const [previewData, setPreviewData] = useState()
  const [showBasicPayrollDetailedView, setShowBasicPayrollDetailedView] =
    useState(false)
  const { mutateAsync: accessPayslipById } = useAccessPayslipById()
  const { data: basicPayroll } = useRefBasicPayrollView(
    refId,
    pagination?.limit,
    pagination?.page,
    pagination?.statusFilter,
    pagination?.search
  )

  const { mutateAsync: checkTransactionStatus } = useCheckTransactionStatus()
  const { mutateAsync: sendPayslip } = useSendSingleBasicPayslip()

  const history = useHistory()
  const { mutateAsync: revertPayroll } = useRevertPayroll()

  // useEffect(() => {
  //   if (basicPayroll) {
  //     if (loading === false && basicPayroll.data.length < 1){
  //       revertPayroll().then(() => {
  //         history.push('/payroll', {tab: 2})
  //       })
  //     }
  //   }
  // }, []);

  const printHandler = (index) => {
    store.dispatch(setIsLoading(true))
    const printElement = ReactDOMServer.renderToString(
      BasicPayslipPDFContent(company, basicPayroll.data[index])
    )
    var opt = {
      margin: 0,
      filename: basicPayroll.data[index]?.ref + ' - basic-payslip.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      pagebreak: { mode: 'avoid-all', before: '#page2el' },
      jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
    }
    html2pdf().set(opt).from(printElement).save()
    store.dispatch(setIsLoading(false))
  }

  const tableConfig = {
    headers: ['Employee Name', 'Amount', 'Fee', 'Total'],
    keys: ['employeeName', 'formatted_net_pay', 'trans_cost', 'total'],
    mobileHeader: {
      left: {
        title: 'Employee Name',
        key: 'employeeName',
      },
      right: {
        title: 'Amount',
        key: 'net_pay',
      },
    },
  }

  const actionConfig = [
    {
      name: 'Details',
      color: 'green',
      action: (id) => {
        let index = basicPayroll.data.findIndex((item) => item.id === id)
        setPreviewData(basicPayroll.data[index])
        setShowBasicPayrollDetailedView(true)
      },
    },
    {
      name: 'Download Payslip',
      color: 'red',
      action: (id) => {
        let index = basicPayroll.data.findIndex((item) => item.id === id)
        if (index !== -1) {
          printHandler(index)
        }
      },
    },
    {
      name: 'Send Payslip',
      color: 'orange',
      action: (id) => {
        let index = basicPayroll.data.findIndex((item) => item.id === id)
        sendPayslip({ id: basicPayroll.data[index].id })
      },
    },
  ]

  const statusConfig = [
    {
      label: 'Pending',
      color: 'orange',
      value: 0,
    },
    {
      label: 'Successful',
      color: 'green',
      value: 1,
    },
    {
      label: 'Failed',
      color: 'red',
      value: 1,
    },
  ]

  const bulkActionConfig = [
    {
      label: 'Access Payslip',
      value: 'active',
      action: (data) => {
        let newData = data.split(',')
        let result = []

        newData.forEach((id) => {
          let index = basicPayroll.data.findIndex((item) => item.id == id)
          if (index != -1) {
            result.push(basicPayroll.data[index].id)
          }
        })
        accessPayslipById({ salaries: result })
      },
    },
  ]

  return (
    <DashboardLayout title='Basic Payroll View'>
      {unauthorized ? (
        <UnauthorizedPage />
      ) : (
        <>
          {previewData && showBasicPayrollDetailedView ? (
            <BasicPayrollDetailedView
              isOpen={showBasicPayrollDetailedView}
              closeModal={() => setShowBasicPayrollDetailedView(false)}
              viewData={previewData}
              previewType={'view'}
            />
          ) : null}
          <div className='flex flex-col'>
            <div className='flex flex-col bg-white rounded'>
              <div className='flex flex-col items-start px-4 gap-[10px] my-2 mt-3'>
                <div className='p3-bold header-4'>Basic Payroll Breakdown</div>
                <div className='flex items-center my-3 px-4 border-secondary-4 border-[1.2px] rounded-lg p-3 mt-2 bg-color-warning-light max-w-[500px]'>
                  <div className='w-[100px] pr-2 flex flex-row items-center '>
                    <img src={WarningSVG} alt='' srcSet='' />
                  </div>
                  <div className='text-[12px] text-justify'>
                    <span className='font-normal'>
                      <span className='font-extrabold'>Payslip Option:</span> If
                      payslip was not paid for during the process of making
                      payment, you will be charged ₦100 for every employee you
                      want to send payslip to. To send select the employees and
                      use bulk action to access payslip.
                    </span>
                  </div>
                </div>
                {/* <div className='flex flex-col md:flex-row items-start gap-[10px] md:items-center'>
                <div className='md:w-fit w-[100%]'>
                  <Button
                  text='Export'
                  type='submit'
                  theme='primary'
                  className='flex gap-2 !h-[35px] w-fit p-2'
                  textClass={'!text-[11px]'}
                  leftIcon={'export'}
                  onClick={() => ""}
                  />
                </div>
              </div> */}
              </div>
              <hr className='divider mt-2 mb-2' />
              <div className='w-[100%]'>
                <DataTable
                  data={basicPayroll}
                  tableConfig={tableConfig}
                  statusConfig={statusConfig}
                  actionConfig={actionConfig}
                  updatePagination={(data) => setPagination(data)}
                  computedActions={true}
                  filterByStatus={true}
                  searchData={true}
                  bulkActionConfig={bulkActionConfig}    
                />
              </div>
            </div>
          </div>
        </>
      )}
    </DashboardLayout>
  )
}

export default BasicPayrollViewPage
